export const isAllDayEvent = (calendarItem) => {
  return !!calendarItem.pin && !!calendarItem.pin.date
}
